export { default } from "./ToggleSwitchRow-component";
